module.exports = __webpack_public_path__ + "img/homepage_2@3x.bc791332.jpg";